/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */

import React from 'react';
import SiteInfoFormContainer from 'containers/forms/SiteInfoFormContainer';
import Header from 'components/Header';
import MigrationBanner from 'components/MigrationBanner';
import SiteMap from 'containers/maps/SiteValidationMapContainer';

const InputsPage = () => (
  <div className="inputs-page app-page">
    <Header />
    <div className="container main-container">
      <MigrationBanner />
      <div className="row">
        <div className="col col-md-6">
          <h1>Create Report</h1>
          <SiteInfoFormContainer />
        </div>
        <div className="col col-md-6">
          <SiteMap />
        </div>
      </div>
    </div>
  </div>
);
export default InputsPage;
